'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FORGOT_PASSWORD = "Forgot password ?";
var RESET_PASSWORD = "Reset Password";
var LOGIN_BUTTON_TEXT = "Login";

var ForgotPasswordComponent = function (_React$Component) {
    _inherits(ForgotPasswordComponent, _React$Component);

    function ForgotPasswordComponent(props) {
        _classCallCheck(this, ForgotPasswordComponent);

        var _this = _possibleConstructorReturn(this, (ForgotPasswordComponent.__proto__ || Object.getPrototypeOf(ForgotPasswordComponent)).call(this, props));

        _this.submitResetPassword = function (e) {
            e.preventDefault();

            var self = _this;
            self.setState({
                error: null
            });

            var email = _this.fusername.value;

            if (Utils.isEmpty(email)) {
                _this.setState({
                    error: "Please enter email address."
                });
                return;
            }

            Utils.showSpinner();
            _parse2.default.User.requestPasswordReset(email).then(function (success) {
                Utils.hideSpinner();
                _this.setState({
                    error: null,
                    isPasswordResetReqSent: true
                });
            }, function (error) {
                console.log(JSON.stringify(error));
                Utils.hideSpinner();
                _this.setState({
                    error: error.message,
                    isPasswordResetReqSent: false
                });
            });
        };

        _this.state = {
            error: null,
            isPasswordResetReqSent: false
        };
        return _this;
    }

    _createClass(ForgotPasswordComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fusername.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: "row" },
                _react2.default.createElement(
                    'div',
                    { className: "col-md-12 col-lg-12" },
                    _react2.default.createElement(
                        'div',
                        { className: 'login align-items-center py-2' },
                        _react2.default.createElement(
                            'div',
                            { className: "container" },
                            _react2.default.createElement(
                                'div',
                                { className: "row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'mx-auto no-gutter py-2 col-lg-12 col-md-12' },
                                    !this.state.isPasswordResetReqSent ? _react2.default.createElement(
                                        'form',
                                        { id: 'passwordResetform', className: 'form-horizontal',
                                            onSubmit: this.submitResetPassword, role: 'form' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group mb-3' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'inputEmail', className: 'mb-1' },
                                                'Email address'
                                            ),
                                            _react2.default.createElement('input', {
                                                ref: function ref(input) {
                                                    return _this2.fusername = input;
                                                },
                                                type: 'email',
                                                id: 'login-username',
                                                className: "form-control",
                                                name: 'username',
                                                placeholder: 'Email address'
                                            })
                                        ),
                                        this.state.error ? _react2.default.createElement(
                                            'div',
                                            { id: 'forgotpass-alert', className: 'alert alert-danger col-sm-12' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row centered errors', style: { marginLeft: 5 } },
                                                _react2.default.createElement('i', { className: 'glyphicon glyphicon-remove' }),
                                                ' ',
                                                this.state.error
                                            )
                                        ) : null,
                                        _react2.default.createElement(
                                            'button',
                                            {
                                                className: "btn btn-lg mt-30 custom-btn-outline-primary" + " btn-block btn-login text-uppercase font-weight-bold mb-2",
                                                onClick: this.submitResetPassword },
                                            RESET_PASSWORD
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-center pt-3' },
                                            'Already have an account? ',
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'text-danger', onClick: this.props.showLoginBox },
                                                'Sign In'
                                            )
                                        )
                                    ) : _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-center pt-2' },
                                            'Please check your inbox to reset your password, then login.'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-center pt-2' },
                                            'Already have an account? ',
                                            _react2.default.createElement(
                                                'a',
                                                { className: 'text-danger', onClick: this.props.showLoginBox },
                                                'Sign In'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ForgotPasswordComponent;
}(_react2.default.Component);

exports.default = ForgotPasswordComponent;


//////////////////
// WEBPACK FOOTER
// ./src/components/login/ForgotPassword.jsx
// module id = 539
// module chunks = 0